const goalMain = {
  title: 'НАША МЕТА',
  paragraphs: [
    'Зробити українську технологію надійною зброєю, яка допомагає зберегти життя захисників і досягти переваги на полі бою.',
    'Ми забезпечуємо українські підрозділи ударними БпЛА, які ефективно виконують бойові завдання навіть в умовах активної дії РЕБ — без GPS та зовнішнього керування. ',
  ],
  cards: {
    bpla: {
      title: '1500',
      description: 'БПЛА виконують бойові завдання',
    },
    defence: {
      title: '15М',
      description: 'Вартість найдорожчої знищеної цілі',
    },
    team: {
      title: '100',
      description: 'Підрозділів працюють з нами',
    },
  },
}
export default goalMain
